export const supportedLocales = {
  en: "English",
  pt: "Portugues",
  es: "Spanish"
};
export const fallbackLocale = "pt";